import { render, staticRenderFns } from "./updataflooring.vue?vue&type=template&id=1251ae02&scoped=true&"
import script from "./updataflooring.vue?vue&type=script&lang=js&"
export * from "./updataflooring.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updataflooring.vue?vue&type=style&index=1&id=1251ae02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251ae02",
  null
  
)

export default component.exports